/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import DashletSuccessIcon from '../../components/elements/DashletSuccessIcon'
import DashletDeclineIcon from '../../components/elements/DashletDeclineIcon'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'

export default function AchProcessorDashlet({ endpointPath, dropdownOptions }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [module, setModule] = useState()
  const modules = useSelector(selectModules)

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        const m = modules.data.find((e) => e.code_key === 'ach_processor')
        setModule(m)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name;
    }
    const data = module.module_fields.find(
      (header) => header.column_name === column_name
    )
    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Ach Processor Detail</p>
      </div>
      <div className="message-body py-0 px-1" style={{ lineHeight: 1.40 }}>
        {loaded && row && row.id && (
          <>
            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader("id")}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-link is-size-8">
                <Link
                  key={`loan-dashlet-view-${row.id}`}
                  to={`/ach_processor/${row.id}`}
                  className="lox-has-text-decoration-none"
                >
                  {row.id}
                </Link>
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('code_key')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.code_key || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('name')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('is_active')}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_active == 0 ? (
                  <DashletDeclineIcon />
                ) : (
                  <DashletSuccessIcon />
                )}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('is_debit')}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_debit == 0 ? (
                  <DashletDeclineIcon />
                ) : (
                  <DashletSuccessIcon />
                )}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('assignment_frequency_percent')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.assignment_frequency_percent || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('transaction_limit')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.transaction_limit || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('cutoff_time')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.cutoff_time || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('timezone_dropdown_option_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {dropdownOptions[row.timezone_dropdown_option_id]?.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('portfolio_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.portfolio_label || '-'}
              </p>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}
